import React from 'react';

import CheckOutline from '@crehana/crehana-icons/lib/CheckOutline';
import Alert from '@crehana/crehana-icons/lib/Alert';
import WarningV2 from '@crehana/crehana-icons/lib/WarningV2';
import InfoOutline from '@crehana/crehana-icons/lib/InfoOutline';

import { IconProps } from '../Buttons/helpers';
import { greenMain, yellowMain, redMain, purple } from './colors';
import { ColorType } from './types';

export type State = 'success' | 'warning' | 'alert' | 'info';

export const stateColors: { [key in State]: ColorType } = {
  success: 'green-main',
  warning: 'yellow-main',
  alert: 'red-main',
  info: 'purple-main',
};

export const stateIcons: { [key in State]: React.ComponentType<IconProps> } = {
  success: CheckOutline,
  warning: Alert,
  alert: WarningV2,
  info: InfoOutline,
};

export const stateIconColors: { [key in State]: string } = {
  success: greenMain,
  warning: yellowMain,
  alert: redMain,
  info: purple,
};
